export default [
  {
    path: '/conversation-overview',
    name: 'conversation-overview',
    component: () => import('@/views/conversationOverview/View.vue'),
    meta: {
      pageTitle: 'breadcrumb.conversationOverview',
      navActiveLink: 'conversation-overview',
      resource: ['report-conversation-overview', 'report-call-center-overview'],
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.conversationOverview',
          active: true,
        },
      ],
    },
  },
]
